import { createFileRoute } from "@tanstack/react-router";
import { pageHead } from "@/client/lib/page";
import { DefinirSenhaPage } from "@/client/modules/auth/definir-senha-page";

/** Convite de primeiro acesso e redefinição de senha: o link do e-mail abre aqui (público, sem indexar). */
export const Route = createFileRoute("/definir-senha")({
  validateSearch: (s: Record<string, unknown>): { token?: string; tipo: "convite" | "redefinicao" } => ({
    token: typeof s.token === "string" ? s.token : undefined,
    tipo: s.tipo === "convite" ? "convite" : "redefinicao",
  }),
  head: () => ({
    ...pageHead("Definir senha"),
    meta: [...pageHead("Definir senha").meta, { name: "robots", content: "noindex" }],
  }),
  component: DefinirSenha,
});

function DefinirSenha() {
  const { token, tipo } = Route.useSearch();
  return <DefinirSenhaPage token={token} tipo={tipo} />;
}
